import React from "react";
import { IconProps } from "@/components/Icon";
interface Mail01IconProps extends Omit<IconProps, "children"> {}

export const Mail01Icon = ({ ...props }: Mail01IconProps) => {
  return (
    <svg
      width="19px"
      height="15px"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.833496 3.33334L7.6376 8.09621C8.18857 8.4819 8.46406 8.67474 8.76372 8.74943C9.02841 8.81541 9.30525 8.81541 9.56994 8.74943C9.8696 8.67474 10.1451 8.4819 10.6961 8.09621L17.5002 3.33334M4.8335 14.1667H13.5002C14.9003 14.1667 15.6004 14.1667 16.1351 13.8942C16.6055 13.6545 16.988 13.2721 17.2277 12.8017C17.5002 12.2669 17.5002 11.5668 17.5002 10.1667V4.83334C17.5002 3.43321 17.5002 2.73315 17.2277 2.19837C16.988 1.72796 16.6055 1.34551 16.1351 1.10583C15.6004 0.833344 14.9003 0.833344 13.5002 0.833344H4.8335C3.43336 0.833344 2.7333 0.833344 2.19852 1.10583C1.72811 1.34551 1.34566 1.72796 1.10598 2.19837C0.833496 2.73315 0.833496 3.43321 0.833496 4.83334V10.1667C0.833496 11.5668 0.833496 12.2669 1.10598 12.8017C1.34566 13.2721 1.72811 13.6545 2.19852 13.8942C2.7333 14.1667 3.43336 14.1667 4.8335 14.1667Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
